class IntlCountry {
    constructor(name, currency, symbol) {
        this.name = name
        this.currency = currency
        this.symbol = symbol
    }
}

const europeCurrencyData = [
    new IntlCountry("Albania", "USD"),
    new IntlCountry("Andorra", "EUR"),
    new IntlCountry("Austria", "EUR"),
    new IntlCountry("Belgium", "EUR"),
    new IntlCountry("Bosnia & Herzegovina", "USD"),
    new IntlCountry("Bulgaria", "BGN"),
    new IntlCountry("Croatia", "HRK"),
    new IntlCountry("Czechia", "CZK"),
    new IntlCountry("Denmark", "DKK"),
    new IntlCountry("Estonia", "EUR"),
    new IntlCountry("Finland", "EUR"),
    new IntlCountry("France", "EUR"),
    new IntlCountry("Germany", "EUR"),
    new IntlCountry("Gibraltar", "USD"),
    new IntlCountry("Greece", "EUR"),
    new IntlCountry("Guernsey", "GBP"),
    new IntlCountry("Hungary", "HUF"),
    new IntlCountry("Iceland", "ISK"),
    new IntlCountry("Ireland", "EUR"),
    new IntlCountry("Italy", "EUR"),
    new IntlCountry("Jersey", "GBP"),
    new IntlCountry("Latvia", "EUR"),
    new IntlCountry("Liechtenstein", "CHF"),
    new IntlCountry("Lithuania", "EUR"),
    new IntlCountry("Luxembourg", "EUR"),
    new IntlCountry("Malta", "EUR"),
    new IntlCountry("Monaco", "EUR"),
    new IntlCountry("Montenegro", "EUR"),
    new IntlCountry("Netherlands", "EUR"),
    new IntlCountry("Norway", "NOK"),
    new IntlCountry("Slovakia", "EUR"),
    new IntlCountry("Slovenia", "EUR"),
    new IntlCountry("Spain", "EUR"),
    new IntlCountry("Sweden", "SEK"),
    new IntlCountry("Switzerland", "CHF"),
    new IntlCountry("Turkey", "TRY"),
    new IntlCountry("United Kingdom", "GBP")
]

const oceaniaCurrencyData = [
    new IntlCountry("Australia", "AUD"),
    new IntlCountry("Fiji", "FJD"),
    new IntlCountry("New Caledonia", "USD"),
    new IntlCountry("New Zealand", "NZD"),
    new IntlCountry("Papua New Guinea", "PGK")
]

const asiaCurrencyData = [
    new IntlCountry("Bahrain", "EUR"),
    new IntlCountry("Bangladesh", "BDT"),
    new IntlCountry("Bhutan", "USD"),
    new IntlCountry("Brunei", "USD"),
    new IntlCountry("Cambodia", "KHR"),
    new IntlCountry("China", "CNY"),
    new IntlCountry("Cyprus", "EUR"),
    new IntlCountry("Hong Kong SAR", "HKD"),
    new IntlCountry("India", "INR"),
    new IntlCountry("Indonesia", "IDR"),
    new IntlCountry("Israel", "ILS"),
    new IntlCountry("Japan", "JPY"),
    new IntlCountry("Jordan", "EUR"),
    new IntlCountry("Kuwait", "KWD"),
    new IntlCountry("Laos", "USD"),
    new IntlCountry("Lebanon", "USD"),
    new IntlCountry("Macao SAR", "MOP"),
    new IntlCountry("Malaysia", "MYR"),
    new IntlCountry("Maldives", "MVR"),
    new IntlCountry("Mongolia", "MNT"),
    new IntlCountry("Oman", "OMR"),
    new IntlCountry("Pakistan", "PKR"),
    new IntlCountry("Philippines", "PHP"),
    new IntlCountry("Qatar", "QAR"),
    new IntlCountry("Saudi Arabia", "SAR"),
    new IntlCountry("Singapore", "SGD"),
    new IntlCountry("South Korea", "KRW"),
    new IntlCountry("Sri Lanka", "LKR"),
    new IntlCountry("Taiwan", "TWD"),
    new IntlCountry("Thailand", "THB"),
    new IntlCountry("United Arab Emirates", "AED"),
    new IntlCountry("Vietnam", "VND")
]

const northAmericaCurrencyData = [
    new IntlCountry("Antigua & Barbuda", "XCD"),
    new IntlCountry("Aruba", "AWG"),
    new IntlCountry("Bahamas", "BSD"),
    new IntlCountry("Barbados", "BBD"),
    new IntlCountry("Belize", "BZD"),
    new IntlCountry("Bermuda", "BMD"),
    new IntlCountry("Canada", "CAD"),
    new IntlCountry("Cayman Islands", "KYD"),
    new IntlCountry("Costa Rica", "CRC"),
    new IntlCountry("Dominica", "XCD"),
    new IntlCountry("Dominican Republic", "DOP"),
    new IntlCountry("El Salvador", "USD"),
    new IntlCountry("Grenada", "XCD"),
    new IntlCountry("Guadeloupe", "EUR"),
    new IntlCountry("Guatemala", "GTQ"),
    new IntlCountry("Haiti", "USD"),
    new IntlCountry("Honduras", "HNL"),
    new IntlCountry("Jamaica", "JMD"),
    new IntlCountry("Martinique", "EUR"),
    new IntlCountry("Mexico", "MXN"),
    new IntlCountry("Montserrat", "XCD"),
    new IntlCountry("Nicaragua", "NIO"),
    new IntlCountry("Panama", "USD"),
    new IntlCountry("Trinidad & Tobago", "TTD"),
    new IntlCountry("Turks & Caicos Islands", "USD"),
    new IntlCountry("United States", "USD")
]

const southAmericaCurrencyData = [
    new IntlCountry("Argentina", "ARS"),
    new IntlCountry("Bolivia", "BOB"),
    new IntlCountry("Brazil", "BRL"),
    new IntlCountry("Chile", "CLP"),
    new IntlCountry("Colombia", "COP"),
    new IntlCountry("Ecuador", "USD"),
    new IntlCountry("French Guiana", "EUR"),
    new IntlCountry("Guyana", "USD"),
    new IntlCountry("Paraguay", "PYG"),
    new IntlCountry("Peru", "PEN"),
    new IntlCountry("Uruguay", "UYU")
]

const africaCurrencyData = [
    new IntlCountry("Benin", "USD"),
    new IntlCountry("Botswana", "USD"),
    new IntlCountry("Burkina Faso", "USD"),
    new IntlCountry("Cameroon", "USD"),
    new IntlCountry("Chad", "USD"),
    new IntlCountry("Egypt", "USD"),
    new IntlCountry("Ethiopia", "USD"),
    new IntlCountry("Gabon", "USD"),
    new IntlCountry("Ghana", "USD"),
    new IntlCountry("Kenya", "KES"),
    new IntlCountry("Lesotho", "USD"),
    new IntlCountry("Madagascar", "USD"),
    new IntlCountry("Mauritius", "USD"),
    new IntlCountry("Morocco", "MAD"),
    new IntlCountry("Nigeria", "NGN"),
    new IntlCountry("Rwanda", "USD"),
    new IntlCountry("Senegal", "USD"),
    new IntlCountry("South Africa", "ZAR"),
    new IntlCountry("Tanzania", "USD"),
    new IntlCountry("Togo", "USD"),
    new IntlCountry("Uganda", "USD")
]

const IntlCountryData = {
    europe: europeCurrencyData,
    oceania: oceaniaCurrencyData,
    asia: asiaCurrencyData,
    "north-america": northAmericaCurrencyData,
    "south-america": southAmericaCurrencyData,
    africa: africaCurrencyData
}

export default IntlCountryData
